import Vue from 'vue'
import Router from 'vue-router'
import Layout from '@/layout/AppMain'
Vue.use(Router)


export const constantRoutes = [
    {
      path: '/',
      component: Layout,
      hidden: true,
      redirect: '/home',
      children: [
        {
          path: 'home',
          isNarbar:true,
          component: () => import('@/views/HomePage')
        },
        {
          path: 'product',
          isNarbar:true,
          component: () => import('@/views/ProductPage')
        },
        {
          path: 'productsdetail',
          isNarbar:false,
          component: () => import('@/views/ProductsDetailPage')
        },
        {
          path: 'about',
          isNarbar:true,
          component: () => import('@/views/AboutPage')
        },
        {
          path: 'services',
          isNarbar:true,
          component: () => import('@/views/ServicesPage')
        },
        {
          path: 'industries',
          isNarbar:true,
          component: () => import('@/views/IndustriesPage')
        },
        {
          path: 'contact',
          isNarbar:true,
          component: () => import('@/views/ContactPage')
        }
      ]
    },
]

const createRouter = () => new Router({
    // mode: 'history', // require service support
    scrollBehavior: () => ({ y: 0 }),
    routes: constantRoutes
  })
  
const router = createRouter()

export default router
